// True when no send can reach this player's family; absent (loading) or null (unknown) is not a gap.
export const isContactReachGap = (contactReach?: ContactReach | null): contactReach is Exclude<ContactReach, 'REACHABLE'> =>
  !!contactReach && contactReach !== 'REACHABLE';
